// inter
import inter300 from '@fontsource/inter/300.css?url'
import inter400 from '@fontsource/inter/400.css?url'
import inter500 from '@fontsource/inter/500.css?url'
import inter600 from '@fontsource/inter/600.css?url'
import inter700 from '@fontsource/inter/700.css?url'
import inter800 from '@fontsource/inter/800.css?url'
import inter900 from '@fontsource/inter/900.css?url'
import inter300woff2 from '@fontsource/inter/files/inter-latin-300-normal.woff2'
import inter400woff2 from '@fontsource/inter/files/inter-latin-400-normal.woff2'
import inter500woff2 from '@fontsource/inter/files/inter-latin-500-normal.woff2'
import inter600woff2 from '@fontsource/inter/files/inter-latin-600-normal.woff2'
import inter700woff2 from '@fontsource/inter/files/inter-latin-700-normal.woff2'
import inter800woff2 from '@fontsource/inter/files/inter-latin-800-normal.woff2'
import inter900woff2 from '@fontsource/inter/files/inter-latin-900-normal.woff2'
// lato
import lato300italic from '@fontsource/lato/300-italic.css?url'
import lato300 from '@fontsource/lato/300.css?url'
import lato400italic from '@fontsource/lato/400-italic.css?url'
import lato400 from '@fontsource/lato/400.css?url'
import lato700italic from '@fontsource/lato/700-italic.css?url'
import lato700 from '@fontsource/lato/700.css?url'
import lato900italic from '@fontsource/lato/900-italic.css?url'
import lato900 from '@fontsource/lato/900.css?url'
import lato300woff2 from '@fontsource/lato/files/lato-latin-300-normal.woff2'
import lato400woff2 from '@fontsource/lato/files/lato-latin-400-normal.woff2'
import lato700woff2 from '@fontsource/lato/files/lato-latin-700-normal.woff2'
import lato900woff2 from '@fontsource/lato/files/lato-latin-900-normal.woff2'
// Merriweather
import merriweather300italic from '@fontsource/merriweather/300-italic.css?url'
import merriweather300 from '@fontsource/merriweather/300.css?url'
import merriweather400italic from '@fontsource/merriweather/400-italic.css?url'
import merriweather400 from '@fontsource/merriweather/400.css?url'
import merriweather700italic from '@fontsource/merriweather/700-italic.css?url'
import merriweather700 from '@fontsource/merriweather/700.css?url'
import merriweather900italic from '@fontsource/merriweather/900-italic.css?url'
import merriweather900 from '@fontsource/merriweather/900.css?url'
import merriweather300woff2 from '@fontsource/merriweather/files/merriweather-latin-300-normal.woff2'
import merriweather400woff2 from '@fontsource/merriweather/files/merriweather-latin-400-normal.woff2'
import merriweather700woff2 from '@fontsource/merriweather/files/merriweather-latin-700-normal.woff2'
import merriweather900woff2 from '@fontsource/merriweather/files/merriweather-latin-900-normal.woff2'
// Montserrat
import montserrat300italic from '@fontsource/montserrat/300-italic.css?url'
import montserrat300 from '@fontsource/montserrat/300.css?url'
import montserrat400italic from '@fontsource/montserrat/400-italic.css?url'
import montserrat400 from '@fontsource/montserrat/400.css?url'
import montserrat500italic from '@fontsource/montserrat/500-italic.css?url'
import montserrat500 from '@fontsource/montserrat/500.css?url'
import montserrat600italic from '@fontsource/montserrat/600-italic.css?url'
import montserrat600 from '@fontsource/montserrat/600.css?url'
import montserrat700italic from '@fontsource/montserrat/700-italic.css?url'
import montserrat700 from '@fontsource/montserrat/700.css?url'
import montserrat300woff2 from '@fontsource/montserrat/files/montserrat-latin-300-normal.woff2'
import montserrat400woff2 from '@fontsource/montserrat/files/montserrat-latin-400-normal.woff2'
import montserrat500woff2 from '@fontsource/montserrat/files/montserrat-latin-500-normal.woff2'
import montserrat600woff2 from '@fontsource/montserrat/files/montserrat-latin-600-normal.woff2'
import montserrat700woff2 from '@fontsource/montserrat/files/montserrat-latin-700-normal.woff2'
// Open Sans
import openSans300italic from '@fontsource/open-sans/300-italic.css?url'
import openSans300 from '@fontsource/open-sans/300.css?url'
import openSans400italic from '@fontsource/open-sans/400-italic.css?url'
import openSans400 from '@fontsource/open-sans/400.css?url'
import openSans500italic from '@fontsource/open-sans/500-italic.css?url'
import openSans500 from '@fontsource/open-sans/500.css?url'
import openSans600italic from '@fontsource/open-sans/600-italic.css?url'
import openSans600 from '@fontsource/open-sans/600.css?url'
import openSans700italic from '@fontsource/open-sans/700-italic.css?url'
import openSans700 from '@fontsource/open-sans/700.css?url'
import openSans300woff2 from '@fontsource/open-sans/files/open-sans-latin-300-normal.woff2'
import openSans400woff2 from '@fontsource/open-sans/files/open-sans-latin-400-normal.woff2'
import openSans500woff2 from '@fontsource/open-sans/files/open-sans-latin-500-normal.woff2'
import openSans600woff2 from '@fontsource/open-sans/files/open-sans-latin-600-normal.woff2'
import openSans700woff2 from '@fontsource/open-sans/files/open-sans-latin-700-normal.woff2'
// Playfair Display
import playfairDisplay400italic from '@fontsource/playfair-display/400-italic.css?url'
import playfairDisplay400 from '@fontsource/playfair-display/400.css?url'
import playfairDisplay500italic from '@fontsource/playfair-display/500-italic.css?url'
import playfairDisplay500 from '@fontsource/playfair-display/500.css?url'
import playfairDisplay600italic from '@fontsource/playfair-display/600-italic.css?url'
import playfairDisplay600 from '@fontsource/playfair-display/600.css?url'
import playfairDisplay700italic from '@fontsource/playfair-display/700-italic.css?url'
import playfairDisplay700 from '@fontsource/playfair-display/700.css?url'
import playfairDisplay400woff2 from '@fontsource/playfair-display/files/playfair-display-latin-400-normal.woff2'
import playfairDisplay500woff2 from '@fontsource/playfair-display/files/playfair-display-latin-500-normal.woff2'
import playfairDisplay600woff2 from '@fontsource/playfair-display/files/playfair-display-latin-600-normal.woff2'
import playfairDisplay700woff2 from '@fontsource/playfair-display/files/playfair-display-latin-700-normal.woff2'
// Roboto
import roboto300italic from '@fontsource/roboto/300-italic.css?url'
import roboto300 from '@fontsource/roboto/300.css?url'
import roboto400italic from '@fontsource/roboto/400-italic.css?url'
import roboto400 from '@fontsource/roboto/400.css?url'
import roboto500italic from '@fontsource/roboto/500-italic.css?url'
import roboto500 from '@fontsource/roboto/500.css?url'
import roboto700italic from '@fontsource/roboto/700-italic.css?url'
import roboto700 from '@fontsource/roboto/700.css?url'
import roboto300woff2 from '@fontsource/roboto/files/roboto-latin-300-normal.woff2'
import roboto400woff2 from '@fontsource/roboto/files/roboto-latin-400-normal.woff2'
import roboto500woff2 from '@fontsource/roboto/files/roboto-latin-500-normal.woff2'
import roboto700woff2 from '@fontsource/roboto/files/roboto-latin-700-normal.woff2'
import { LinksFunction } from 'react-router'

export const fonts: LinksFunction = () => [
  // Open Sans
  { href: openSans300woff2, as: 'font', type: 'font/woff2', crossOrigin: 'anonymous', rel: 'preload' },
  { href: openSans400woff2, as: 'font', type: 'font/woff2', crossOrigin: 'anonymous', rel: 'preload' },
  { href: openSans500woff2, as: 'font', type: 'font/woff2', crossOrigin: 'anonymous', rel: 'preload' },
  { href: openSans600woff2, as: 'font', type: 'font/woff2', crossOrigin: 'anonymous', rel: 'preload' },
  { href: openSans700woff2, as: 'font', type: 'font/woff2', crossOrigin: 'anonymous', rel: 'preload' },

  { rel: 'stylesheet', href: openSans300 },
  { rel: 'stylesheet', href: openSans400 },
  { rel: 'stylesheet', href: openSans500 },
  { rel: 'stylesheet', href: openSans600 },
  { rel: 'stylesheet', href: openSans700 },
  { rel: 'stylesheet', href: openSans300italic },
  { rel: 'stylesheet', href: openSans400italic },
  { rel: 'stylesheet', href: openSans500italic },
  { rel: 'stylesheet', href: openSans600italic },
  { rel: 'stylesheet', href: openSans700italic },

  //Playfair Display
  { href: playfairDisplay400woff2, as: 'font', type: 'font/woff2', crossOrigin: 'anonymous', rel: 'preload' },
  { href: playfairDisplay500woff2, as: 'font', type: 'font/woff2', crossOrigin: 'anonymous', rel: 'preload' },
  { href: playfairDisplay600woff2, as: 'font', type: 'font/woff2', crossOrigin: 'anonymous', rel: 'preload' },
  { href: playfairDisplay700woff2, as: 'font', type: 'font/woff2', crossOrigin: 'anonymous', rel: 'preload' },

  { rel: 'stylesheet', href: playfairDisplay400 },
  { rel: 'stylesheet', href: playfairDisplay500 },
  { rel: 'stylesheet', href: playfairDisplay600 },
  { rel: 'stylesheet', href: playfairDisplay700 },
  { rel: 'stylesheet', href: playfairDisplay400italic },
  { rel: 'stylesheet', href: playfairDisplay500italic },
  { rel: 'stylesheet', href: playfairDisplay600italic },
  { rel: 'stylesheet', href: playfairDisplay700italic },

  // Roboto
  { href: roboto300woff2, as: 'font', type: 'font/woff2', crossOrigin: 'anonymous', rel: 'preload' },
  { href: roboto400woff2, as: 'font', type: 'font/woff2', crossOrigin: 'anonymous', rel: 'preload' },
  { href: roboto500woff2, as: 'font', type: 'font/woff2', crossOrigin: 'anonymous', rel: 'preload' },
  { href: roboto700woff2, as: 'font', type: 'font/woff2', crossOrigin: 'anonymous', rel: 'preload' },

  { rel: 'stylesheet', href: roboto300 },
  { rel: 'stylesheet', href: roboto400 },
  { rel: 'stylesheet', href: roboto500 },
  { rel: 'stylesheet', href: roboto700 },
  { rel: 'stylesheet', href: roboto300italic },
  { rel: 'stylesheet', href: roboto400italic },
  { rel: 'stylesheet', href: roboto500italic },
  { rel: 'stylesheet', href: roboto700italic },

  // Lato
  { href: lato300woff2, as: 'font', type: 'font/woff2', crossOrigin: 'anonymous', rel: 'preload' },
  { href: lato400woff2, as: 'font', type: 'font/woff2', crossOrigin: 'anonymous', rel: 'preload' },
  { href: lato700woff2, as: 'font', type: 'font/woff2', crossOrigin: 'anonymous', rel: 'preload' },
  { href: lato900woff2, as: 'font', type: 'font/woff2', crossOrigin: 'anonymous', rel: 'preload' },

  { rel: 'stylesheet', href: lato300 },
  { rel: 'stylesheet', href: lato400 },
  { rel: 'stylesheet', href: lato700 },
  { rel: 'stylesheet', href: lato900 },
  { rel: 'stylesheet', href: lato300italic },
  { rel: 'stylesheet', href: lato400italic },
  { rel: 'stylesheet', href: lato700italic },
  { rel: 'stylesheet', href: lato900italic },

  // Inter
  { href: inter300woff2, as: 'font', type: 'font/woff2', crossOrigin: 'anonymous', rel: 'preload' },
  { href: inter400woff2, as: 'font', type: 'font/woff2', crossOrigin: 'anonymous', rel: 'preload' },
  { href: inter500woff2, as: 'font', type: 'font/woff2', crossOrigin: 'anonymous', rel: 'preload' },
  { href: inter600woff2, as: 'font', type: 'font/woff2', crossOrigin: 'anonymous', rel: 'preload' },
  { href: inter700woff2, as: 'font', type: 'font/woff2', crossOrigin: 'anonymous', rel: 'preload' },
  { href: inter800woff2, as: 'font', type: 'font/woff2', crossOrigin: 'anonymous', rel: 'preload' },
  { href: inter900woff2, as: 'font', type: 'font/woff2', crossOrigin: 'anonymous', rel: 'preload' },

  { rel: 'stylesheet', href: inter300 },
  { rel: 'stylesheet', href: inter400 },
  { rel: 'stylesheet', href: inter500 },
  { rel: 'stylesheet', href: inter600 },
  { rel: 'stylesheet', href: inter700 },
  { rel: 'stylesheet', href: inter800 },
  { rel: 'stylesheet', href: inter900 },

  // Merriweather
  { href: merriweather300woff2, as: 'font', type: 'font/woff2', crossOrigin: 'anonymous', rel: 'preload' },
  { href: merriweather400woff2, as: 'font', type: 'font/woff2', crossOrigin: 'anonymous', rel: 'preload' },
  { href: merriweather700woff2, as: 'font', type: 'font/woff2', crossOrigin: 'anonymous', rel: 'preload' },
  { href: merriweather900woff2, as: 'font', type: 'font/woff2', crossOrigin: 'anonymous', rel: 'preload' },

  { rel: 'stylesheet', href: merriweather300 },
  { rel: 'stylesheet', href: merriweather400 },
  { rel: 'stylesheet', href: merriweather700 },
  { rel: 'stylesheet', href: merriweather900 },
  { rel: 'stylesheet', href: merriweather300italic },
  { rel: 'stylesheet', href: merriweather400italic },
  { rel: 'stylesheet', href: merriweather700italic },
  { rel: 'stylesheet', href: merriweather900italic },

  // Montserrat
  { href: montserrat300woff2, as: 'font', type: 'font/woff2', crossOrigin: 'anonymous', rel: 'preload' },
  { href: montserrat400woff2, as: 'font', type: 'font/woff2', crossOrigin: 'anonymous', rel: 'preload' },
  { href: montserrat500woff2, as: 'font', type: 'font/woff2', crossOrigin: 'anonymous', rel: 'preload' },
  { href: montserrat600woff2, as: 'font', type: 'font/woff2', crossOrigin: 'anonymous', rel: 'preload' },
  { href: montserrat700woff2, as: 'font', type: 'font/woff2', crossOrigin: 'anonymous', rel: 'preload' },

  { rel: 'stylesheet', href: montserrat300 },
  { rel: 'stylesheet', href: montserrat400 },
  { rel: 'stylesheet', href: montserrat500 },
  { rel: 'stylesheet', href: montserrat600 },
  { rel: 'stylesheet', href: montserrat700 },
  { rel: 'stylesheet', href: montserrat300italic },
  { rel: 'stylesheet', href: montserrat400italic },
  { rel: 'stylesheet', href: montserrat500italic },
  { rel: 'stylesheet', href: montserrat600italic },
  { rel: 'stylesheet', href: montserrat700italic },
]